import { Button, Col, Form, Input, Row } from "antd";
import { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const navigate = useNavigate();
  const onFinish = (values) => {
    if (values?.password !== values?.confirmPassword) {
      swal("Error", "Password and Confirm Password should match", "error");
      return;
    }
    setLoading(true);
    let body = {
      email: userData.email,
      type: "ADMIN",
      password: values?.password,
      oldPassword: values.oldPassword,
    };
    Post(RESET.changePassword, body, token)
      .then((response) => {
        if (response.status) {
          form.resetFields();
          setLoading(false);
          showAlert();
          navigate("/profile");
        }
      })
      .catch((err) => {
        console.log("Error", err);
        setLoading(false);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  // const onFinishFailed = (errorInfo) => {
  //   console.log("Failed:", errorInfo);
  // };
  const showAlert = () => {
    swal("system Alert", "Your password has been updated", "success");
  };
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 p-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-start items-center mb-4">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px]"
            />
            <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
              Change Password
            </h3>
          </div>
          <Row justify="center">
            <Col xs={22} sm={18} md={18} xl={12}>
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6">
                <Form
                  form={form}
                  name="normal_login"
                  onFinish={onFinish}
                  layout="vertical"
                  className="w-full px-8 max-xl:px-2"
                >
                  <Row justify="center">
                    <Col xxl={18} md={24} sm={24} xs={24}>
                      <Form.Item
                        name="oldPassword"
                        label={
                          <p className="font-euclid text-sm max-sm:text-xs text-black font-semibold">
                            Old Password
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input old password!",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Enter Old Password"
                          className="h-12 text-sm font-euclid bg-gray-100 "
                          autoComplete={false}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center">
                    <Col xxl={18} md={24} sm={24} xs={24}>
                      <Form.Item
                        name="password"
                        label={
                          <p className="font-euclid text-sm max-sm:text-xs text-black font-semibold">
                            New Password
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input password!",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Enter New Password"
                          className="h-12 text-sm font-euclid bg-gray-100 "
                          autoComplete={false}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center">
                    <Col xxl={18} md={24} sm={24} xs={24}>
                      <Form.Item
                        name="confirmPassword"
                        label={
                          <p className="font-euclid text-sm max-sm:text-xs text-black font-semibold">
                            Confirm Password
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input password!",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Confirm Password"
                          className="h-12 text-sm font-euclid bg-gray-100 "
                          autoComplete={false}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center">
                    <Col md={12}>
                      <Form.Item className="self-center text-center">
                        <Button
                          htmlType="submit"
                          className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm"
                        >
                          {loading ? "LOADING..." : "UPDATE"}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ChangePassword;
